export default __webpack_public_path__ + "static/media/ananya.fb22fd52.png";